/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class RegisteredPayment {
  baseApi = ENV.BASE_API;

  async getRegisteredPayments(studentId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_PAYMENT}/${studentId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createRegisteredPayment(accessToken, registeredPaymentData) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_PAYMENT}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(registeredPaymentData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateRegisteredPayment(accessToken, registeredPaymentId, registeredPaymentData) {
    try {
      const formData = new FormData();
      Object.keys(registeredPaymentData).forEach((key) => {
        formData.append(key, registeredPaymentData[key]);
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_PAYMENT}/${registeredPaymentId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteRegisteredPayment(accessToken, registeredPaymentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_PAYMENT}/${registeredPaymentId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteRegisteredPaymentDefinitely(accessToken, registeredPaymentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_PAYMENT}/delete/${registeredPaymentId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPaymentsByUser(userId, selectedCycle, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_PAYMENT_BY_USER}/${userId}?selectedCycle=${selectedCycle}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAcademicCyclesByUser(userId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ACADEMIC_CYCLE_BY_USER}/${userId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createPayment(accessToken, paymentData) {
    try {
      const formData = new FormData();
      Object.keys(paymentData).forEach((key) => {
        formData.append(key, paymentData[key]);
      });
      const url = `${this.baseApi}/payments`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async confirmPayment(accessToken, paymentId, data) {
    try {
      const url = `${this.baseApi}/payments/${paymentId}/confirm`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getStudentDebts(studentId, accessToken, status = null, academicCycleId = null) {
    try {
      let url = `${this.baseApi}/students/${studentId}/debts`;
      const queryParams = new URLSearchParams();
      if (status) {
        queryParams.append("status", status);
      }
      if (academicCycleId) {
        queryParams.append("academicCycleId", academicCycleId);
      }
      const queryString = queryParams.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPaymentHistory(studentId, accessToken, limit = 50) {
    try {
      const url = `${this.baseApi}/students/${studentId}/payment-history?limit=${limit}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async waiveDebt(accessToken, debtId, notes) {
    try {
      const url = `${this.baseApi}/student-debts/${debtId}/waive`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ notes }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getStudentSummary(studentId, accessToken) {
    try {
      const url = `${this.baseApi}/reports/student-summary/${studentId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPayments(accessToken, queryParams = {}) {
    try {
      const query = new URLSearchParams(queryParams).toString();
      const url = `${this.baseApi}/payments?${query}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}

